/* ---------- hero candles: range, then a breakout that leaves the frame ---------- */
(function drawChart(){
  var svg = document.getElementById("heroChart");
  if (!svg) return;

  var BARS = [
    [112,118,108,115],[115,120,112,113],[113,119,109,118],[118,122,114,116],
    [116,121,112,114],[114,124,113,123],[123,128,120,121],[121,126,117,125],
    [125,131,123,128],[128,133,124,126],[126,134,125,132],[132,138,130,134],
    [134,140,131,136],[136,139,130,133],[133,137,128,131],[131,140,130,139],
    [139,146,137,145],[145,182,144,176]
  ];
  var PRIOR_HIGH = 140, W = 1200, H = 320, PAD = 40, lo = 100, hi = 168;

  function y(p){ return H - PAD - ((p - lo) / (hi - lo)) * (H - PAD * 2); }
  var step = (W - PAD * 2) / BARS.length, bw = step * 0.46, out = "";

  for (var i = 0; i <= 4; i++){
    var gy = PAD + i * ((H - PAD * 2) / 4);
    out += '<line x1="0" x2="' + W + '" y1="' + gy + '" y2="' + gy + '" stroke="#232A32" stroke-width="1"/>';
  }
  out += '<line x1="0" x2="' + W + '" y1="' + y(PRIOR_HIGH) + '" y2="' + y(PRIOR_HIGH) + '"'
       + ' stroke="#FF9E1B" stroke-width="1" stroke-dasharray="5 7" opacity=".55"/>';
  out += '<text x="14" y="' + (y(PRIOR_HIGH) - 10) + '" fill="#FF9E1B" opacity=".8"'
       + ' font-family="IBM Plex Mono, monospace" font-size="11" letter-spacing="2">PRIOR HIGH</text>';

  BARS.forEach(function(b, i){
    var o = b[0], h = b[1], l = b[2], c = b[3];
    var cx = PAD + step * i + step / 2;
    var col = (i >= BARS.length - 2) ? "#FF9E1B" : (c >= o ? "#3B4753" : "#2A323B");
    var top = Math.min(y(o), y(c));
    var bh  = Math.max(Math.abs(y(o) - y(c)), 2);
    out += '<line x1="' + cx + '" x2="' + cx + '" y1="' + y(h) + '" y2="' + y(l) + '" stroke="' + col + '" stroke-width="2"/>';
    out += '<rect x="' + (cx - bw/2) + '" y="' + top + '" width="' + bw + '" height="' + bh + '" fill="' + col + '"/>';
  });
  svg.innerHTML = out;
})();

/* ---------- lookbook arrows ---------- */
document.querySelectorAll(".look__arrow").forEach(function(btn){
  btn.addEventListener("click", function(){
    var rail  = btn.closest(".look").querySelector(".look__rail");
    var first = rail.querySelector(".look__slide");
    if (!first) return;
    rail.scrollBy({ left: (first.getBoundingClientRect().width + 14) * Number(btn.dataset.dir), behavior: "smooth" });
  });
});

/* ---------- ladder: size select drives the add-to-cart variant ---------- */
document.addEventListener("change", function(e){
  var sel = e.target.closest(".row__pick .pick__select");
  if (!sel) return;
  var row  = sel.closest(".row");
  var hid  = row && row.querySelector('.row__form input[name="id"]');
  if (hid) hid.value = sel.value;
});

/* ---------- product gallery ---------- */
(function gallery(){
  var thumbs = document.getElementById("pdpThumbs");
  var hero   = document.getElementById("pdpHero");
  if (!thumbs || !hero) return;
  thumbs.addEventListener("click", function(e){
    var t = e.target.closest(".pdp__thumb");
    if (!t) return;
    hero.src = t.dataset.full;
    hero.alt = t.alt;
    thumbs.querySelectorAll(".pdp__thumb").forEach(function(x){
      x.setAttribute("aria-current", String(x === t));
    });
  });
})();

/* ---------- product: price follows the selected variant ---------- */
(function variantPrice(){
  var sel   = document.getElementById("variantSelect");
  var price = document.getElementById("pdpPrice");
  if (!sel || !price) return;
  sel.addEventListener("change", function(){
    var opt = sel.options[sel.selectedIndex];
    if (opt && opt.dataset.price) price.textContent = opt.dataset.price;
  });
})();
